import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Sidebar, SidebarSkeleton } from './Sidebar';
import { FullPageLoader } from '../ui/Spinner';
import { useAuth } from '../../contexts/AuthContext';
export function AppShell() {
  const {
    user
  } = useAuth();
  const location = useLocation();
  const [booting, setBooting] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setBooting(false), 900);
    return () => clearTimeout(timer);
  }, []);
  if (!user) {
    return <Navigate to="/" replace state={{
      from: location.pathname
    }} data-id="element-78" data-mp="cl7o9cwitluv" />;
  }
  return <div className="min-h-full w-full bg-white" data-id="element-79" data-mp="7seiclpbg7h7">
      {booting ? <SidebarSkeleton data-id="element-80" data-mp="2uuxh2y44wga" /> : <Sidebar data-id="element-81" data-mp="2tjrqxl3xemj" />}
      <div className="flex min-h-screen flex-col pl-[147px]" data-id="element-82" data-mp="2u3aggil071m">
        {booting ? <FullPageLoader data-id="element-83" data-mp="10a8owdz43spl" /> : <Outlet data-id="element-84" data-mp="10as8dz4eup5q" />}
      </div>
    </div>;
}